export const getLicenseType = (type: string): string => {
  switch (type) {
    case "regular":
      return "Временная";
    case "perpetual":
      return "Бессрочная";
    case "session":
      return "Сессионная";
    default:
      return type;
  }
};
